export const JOURNAL_TYPES = {
  THEORETICAL: 'theoretical',
  INDIVIDUAL: 'individual',
  INDUSTRIAL: 'industrial',
  FACULTATIVE: 'facultative',
  TEACHERS_PRACTICE: "industrial-accounting"
}

export const JOURNAL_TYPES_API: any = {
  [JOURNAL_TYPES.THEORETICAL]: 1,
  [JOURNAL_TYPES.TEACHERS_PRACTICE]: 4,
  [JOURNAL_TYPES.INDIVIDUAL]: 3,
  [JOURNAL_TYPES.INDUSTRIAL]: 4,
  [JOURNAL_TYPES.FACULTATIVE]: 5
}

export const JOURNAL_QUERY_PARAMS = {
  YEAR: 'year',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  TYPE: 'type',
}

export const JOURNAL_YEAR = {
  PREV: '2022',
  CURRENT: '2023',
  NEXT: '2024',
}